import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export function useAdmin() {
  const [user, setUser] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(async () => {
      try {
        await api.post("/auth/refresh");
        const r = await api.get("/auth/me");
        setUser(r.data);
      } catch {
        setUser(false);
        nav("/admin/login", { replace: true });
      }
    });
  }, [nav]);
  return user;
}

export const AdminLoading = () => (
  <div className="flex justify-center py-32"><Loader2 className="h-8 w-8 animate-spin text-red-500" /></div>
);
